import React from "react";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";

import { Title } from "../../styles";
import { GreetingsContainer, GreetingsContent } from "./styles";

import { FiArrowRight } from "react-icons/fi";
import greetingImage from "../../../../newUXAssets/images/ai_creator_greeting_image.png";

import Button from "../Button";
import { Image } from "antd";

export function Greetings({ hasAccess = false }) {
  return (
    <GreetingsContainer>
      <Title>
        <FormattedMessage id={"sidebar.creator"} />
      </Title>

      <section>
        <Image
          src={greetingImage}
          width={516}
          // placeholder={<Skeleton width={507} height={422.5} />}
          preview={false}
        />
        {hasAccess && <HasAccess />}
        {!hasAccess && <NoAccess />}
      </section>
    </GreetingsContainer>
  );
}

function HasAccess() {
  const history = useHistory();

  const handleStart = () => {
    history.push("/ai-creator/create");
  };

  return (
    <GreetingsContent>
      <h2>
        <FormattedMessage id={"ai_creator.greeting_title.access"} />
      </h2>
      <p>
        <FormattedMessage id={"ai_creator.greeting_description1.access"} />
      </p>
      <p>
        <FormattedMessage id={"ai_creator.greeting_description2.access"} />
      </p>
      <p>
        <FormattedMessage id={"ai_creator.greeting_description3.access"} />
      </p>

      <Button
        width={"sm"}
        icon={<FiArrowRight size={20} />}
        onClick={handleStart}
        label={"ai_creator.start"}
        iconPosition="end"
      />
    </GreetingsContent>
  );
}

function NoAccess() {
  const { whatsapp } = useSelector((state) => state.ai_creator);

  return (
    <GreetingsContent>
      <h2>
        <FormattedMessage id={"ai_creator.greeting_title.no_access"} />
      </h2>
      <p>
        <FormattedMessage id={"ai_creator.greeting_description1.1.no_access"} />
        <span>
          <FormattedMessage
            id={"ai_creator.greeting_description1.2.no_access"}
          />
        </span>
        <FormattedMessage id={"ai_creator.greeting_description1.3.no_access"} />
      </p>
      <p>
        <FormattedMessage id={"ai_creator.greeting_description2.no_access"} />
      </p>

      <Button
        width={"sm"}
        href={`https://wa.me/${whatsapp}`}
        target={"_blank"}
        label={"ai_creator.knowMore"}
      />
    </GreetingsContent>
  );
}
